$(document).ready(function(){            
    $('.ld-focus-sidebar .ld-expandable.ld-expanded').each(function(){
        $(this).closest('.ld-lesson-item').addClass('expanded');
    });
     
    $('.ld-expand-button').on('click', function(e) {
        if($(this).hasClass('ld-expanded')){
            $(this).closest('.ld-lesson-item').removeClass('expanded');
        } else {
            $(this).closest('.ld-lesson-item').addClass('expanded');
        }
    });
    
    // Hide Quiz content on results page
    $('.wpProQuiz_content').on('learndash-quiz-finished', function(status, item, results) {
        $(this).siblings('.ld-tabs').hide();
	});
    
});